module.exports = __webpack_public_path__ + "img/icono_paso4.ea5e3960.png";